import { Table } from 'antd';
import { ColumnProps } from 'antd/es/table';
import React, { useMemo } from 'react';
import { TransactionLog, TransactionType } from '@/models/transaction';
import { getPaymentChannelDesc } from '../../pages/Order/helpers';
import Price from '../Price';

interface Props {
  list: TransactionLog[];
  refundOnly?: boolean;
  paymentOnly?: boolean;
  showCashier?: boolean;
  showAddTime?: boolean;
}
export default ({
  list,
  refundOnly = false,
  paymentOnly = false,
  showCashier = false,
  showAddTime = true,
}: Props) => {
  const showList = (list || []).filter(item => {
    if (refundOnly) {
      return item.type === TransactionType.Refund;
    } else if (paymentOnly) {
      return item.type === TransactionType.Payment;
    }
    return true;
  });

  const columns = useMemo<ColumnProps<TransactionLog>[]>(() => {
    return [
      {
        title: '交易渠道',
        render: (_, log) => {
          return <>{getPaymentChannelDesc(log.paymentMethod)}</>;
        },
      },
      {
        title: '金额',
        render: (_, log) => {
          return <Price value={log.amount} />;
        },
      },
      showAddTime
        ? {
            title: '交易时间',
            render: (_, log) => {
              return log.addTime;
            },
          }
        : null,
      showCashier
        ? {
            title: '收银员',
            render: (_, log) => {
              return log.operator;
            },
          }
        : null,
      {
        title: '渠道单号',
        render: (_, log) => {
          if (log.type === TransactionType.Payment) {
            return log.outTradeNo || 'N/A';
          } else if (log.type === TransactionType.Refund) {
            return log.outRefundNo || 'N/A';
          }
          return 'N/A';
        },
      },
    ].filter(Boolean);
  }, [showCashier, showAddTime]);

  if (showList.length < 1) {
    return <>N/A</>;
  }

  return (
    <Table
      tableLayout="fixed"
      rowKey={'id'}
      size="small"
      dataSource={showList}
      bordered
      pagination={false}
      columns={columns}
    />
  );
};
